import { render, staticRenderFns } from "./CContentTop.vue?vue&type=template&id=2e608d91&scoped=true&"
import script from "./CContentTop.vue?vue&type=script&lang=ts&"
export * from "./CContentTop.vue?vue&type=script&lang=ts&"
import style0 from "./CContentTop.vue?vue&type=style&index=0&id=2e608d91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e608d91",
  null
  
)

export default component.exports